import { ApiResourceMethod } from '@/api/api-requests-factory';
import { BaseResponse } from '@/api/api-requests-factory/models/response.model';
import { DeletePspTagModel } from '@/models/psp-tag/psp-tag.model';

export default class DeletePspTagRequest extends ApiResourceMethod<{}> {
  public perform({ tagId, code }: DeletePspTagModel): Promise<{}> {
    return this.performer.requestWithMapper(
      {
        url: tagId,
        params: code,
      },
      (payload: BaseResponse<{}>) => payload,
    );
  }
}
